import script from "./GlobalVars.vue?vue&type=script&lang=js"
export * from "./GlobalVars.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__